import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { PagesModule } from './pages/pages.module';
import { ChartOption } from './shered/chartOption';
import { IMqttServiceOptions, MqttModule } from 'ngx-mqtt';
import { ServicesProvider } from '././core/service/services';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';

const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
  hostname: 'foodvilla-ems.com',
  port: 1914,
  username: 'richth_mqtt',
  password: 'e170f22c5762',
  protocol: 'wss',
  path: ''
}


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    MqttModule.forRoot(MQTT_SERVICE_OPTIONS),
    BrowserModule,
    AppRoutingModule,
    LayoutModule,
    HttpClientModule,
  ],
  providers: [ChartOption, ServicesProvider, { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
